﻿import config from "../config"
const baseUrl = config.base_url + "container/phenology-indicator/"
export default {
    mockTestIndicators: {
        url: baseUrl + "mockTestIndicators",
        type: "get",
    },
    listIndicatorByPhenologyId: {
        url: baseUrl + "listIndicatorByPhenologyId",
        type: "get",
    },
}

